import type { Client, ClientType } from '@/components/Views/Company/File/file.types';

export type ClientAttrs = Record<keyof Pick<Client, 'first' | 'last' | 'email' | 'phone' | 'role'>, Record<string, string>>;

export interface ClientFormData extends Pick<Client, 'first' | 'last' | 'email' | 'phone'> {
    id: string;
    role?: ClientType;
}

export enum ClientValidationErrorKeys {
    EMAIL = 'email',
    PHONE = 'phone',
    ROLE = 'role',
    FIRST_NAME = 'first_name',
    LAST_NAME = 'last_name',
}

export interface TypedClientError {
    [ClientValidationErrorKeys.EMAIL]: string;
    [ClientValidationErrorKeys.PHONE]: string;
    [ClientValidationErrorKeys.ROLE]: string;
    [ClientValidationErrorKeys.FIRST_NAME]: string;
    [ClientValidationErrorKeys.LAST_NAME]: string;
}
export type ClientValidationErrorResponse = Record<string, string[]>;
export type ClientErrorInput = TypedClientError | TypedClientError[];

export interface AddClientsSuccessResponse {
    success: boolean;
    warnings?: string[];
}

export interface EditClientSuccessResponse {
    success: boolean;
    warning?: string;
}
